/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/337-ctrl': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M11.5 7a.5.5 0 01-.377-.171l-3.124-3.57-3.124 3.57a.5.5 0 11-.753-.659l3.5-4a.502.502 0 01.752 0l3.5 4a.5.5 0 01-.376.83z"/>'
  }
})
